import { Fragment } from "react";

import { Element } from "@craftjs/core";

import { define, prop } from "@/components/builder/utils";

import { MidpathTCPAContinueButtonBlock } from "../..";
import BasePreview from "../../base";

function MidpathTCPAContinueContainerPreview(props) {
  return <BasePreview {...props}>
    <div className="tcpa-continue-container">
      <Element is={MidpathTCPAContinueButtonBlock} id='tcpa-continue-container' />
    </div>
  </BasePreview>
}

export default define('tcpa-continue-container', MidpathTCPAContinueContainerPreview, Fragment)
  .shared(prop.share('MidpathTCPAContinueContainer', 'tcpa-continue-container'), { prefix: false })
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .build()
